import { useQuery } from "@tanstack/react-query";
import { Card, Row, Typography } from "antd";
import React from "react";
import LoaderTsx from "../../../Loader.tsx";
import { getRenewalAwaitingDecisions } from "../../Booking/ducks/service";
import { setAwaitingDecisionData } from "../utilis";
import ProgressBarRow from "./components/ProgressBarRow";
import TimeBlock from "./components/TimeBlock";
import { useDashboardFilterContext } from "../../hooks/DashboardFilterProvider";
import { currencyFormat } from "../../../../../utils/media.js";

const { Title, Text } = Typography;

const AwaitingDecisionCard: React.FC = React.memo(() => {
  const filterData = useDashboardFilterContext();
  const { data: awaitingDecisionData, isLoading: isLoading } = useQuery({
    queryKey: ["renewal-awaiting-decisions", filterData?.queryParams],
    queryFn: () => getRenewalAwaitingDecisions(filterData?.queryParams),
    staleTime: 1000 * 60 * 5, // ✅ 5 minutes
    refetchOnWindowFocus: false, // 👈 disable auto refetch when window regains focus
  });

  return (
    <Card
      style={{
        borderRadius: 12,
        boxShadow: "none",
        minHeight: 398,
      }}
    >
      <Title
        level={5}
        style={{
          margin: 0,
          color: "#1F5782",
          textTransform: "uppercase",
          fontWeight: 400,
        }}
      >
        <span style={{ fontWeight: 700 }}>AWAITING</span>{" "}
        <span style={{ fontWeight: 400 }}>DECISION</span>
      </Title>
      {isLoading ? (
        <LoaderTsx height={"35vh"}></LoaderTsx>
      ) : (
        <>
          <Title
            level={2}
            style={{ margin: "8px 0", fontSize: 40, color: "#234D64" }}
          >
            {
              setAwaitingDecisionData(awaitingDecisionData?.result)
                ?.totoalPendingCount
            }
          </Title>

          <Text style={{ color: "#666" }}>
            Value:{" "}
            {
              setAwaitingDecisionData(awaitingDecisionData?.result)
                ?.totalPendingAmount
            }
          </Text>

          <ProgressBarRow
            totalPercent={
              setAwaitingDecisionData(awaitingDecisionData?.result)
                ?.totalPercentage
            }
            progressData={
              setAwaitingDecisionData(awaitingDecisionData?.result)?.timeBlocks
            }
          />

          <Card
            style={{
              marginTop: 16,
              borderRadius: 8,
              backgroundColor: "#F8F8F8",
              //   padding: "12px",
              border: "none",
            }}
          >
            <Row justify="space-between">
              {setAwaitingDecisionData(
                awaitingDecisionData?.result
              )?.timeBlocks.map((block, index) => (
                <TimeBlock key={index} {...block} />
              ))}
            </Row>
          </Card>
        </>
      )}
    </Card>
  );
});

export default AwaitingDecisionCard;
